/*
 *
 * GiftCardsList actions
 *
 */

import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import { utils } from '../../devUtils';

import {
  DEFAULT_ACTION,
  FETCH_GIFTCARDLIST_SUCCESS,
  FETCH_FILTER_SUCCESS,
  FETCH_RESTURANTLIST_ERROR,
  STORE_CLIENT_ID,
  // ADDTOCART_SUCCESS,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}
const successGiftCardList = (payload) => ({ type: FETCH_GIFTCARDLIST_SUCCESS, payload });
const successFilterData = (payload) => ({ type: FETCH_FILTER_SUCCESS, payload });
const errorAction = (payload) => ({ type: FETCH_RESTURANTLIST_ERROR, payload });
const storeClientId = (payload) => ({ type: STORE_CLIENT_ID, payload });
// const addToCartSuccess = (payload) => ({ type: ADDTOCART_SUCCESS, payload });

/**
 * @todo: this api already hitting from
 * @see /client/containers/HomePage/Loadable.js
 * @return already in the store can be used from there
 */
export const fetchCategoryList = (payload) => async (dispatch, getState, api) => {
  try {
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const category_list = await reqHandler.getHandler(api, endpoint.GET_GIFTCARD_PAGE_FILTERS_LIST, payload, authPrerequist);
    dispatch(successFilterData(category_list));
  } catch (err) {
    dispatch(errorAction(err));
  }
};

export const GLOBAL_GET_GIFTCARD_LIST = (api, payload, authPrerequist) => reqHandler.getHandler(api, endpoint.GET_GIFTCARD_LIST, payload, authPrerequist);

export const fetchGiftCardList = (payload) => async (dispatch, getState, api) => {
  try {
    // const { products, pagination } = await reqHandler.getHandler(api, endpoint.GET_GIFTCARD_LIST, payload);
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const { products, pagination } = await GLOBAL_GET_GIFTCARD_LIST(api, payload, authPrerequist);
    dispatch(successGiftCardList({ data: products, totalRecords: pagination.total_count }));
    dispatch(storeClientId(payload.client_ids));
  } catch (err) {
    dispatch(errorAction(err));
  }
};

// export const addToCartAction = (payload, product_id) => async (dispatch, getState, api) => {
//   try {
//     dispatch(clearDefaultError());
//     const url = `${endpoint.GET_CART_LIST}/${product_id}/items`;
//     const _api = utils.addAuthHeaders(getState, api);
//     const response = await reqHandler.postHandler(_api, url, payload);
//     utils.removeAuthHeaders(_api);
//     if (response.message) {
//       dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, response.message)));
//     } else {
//       dispatch(addToCartSuccess({}));
//       dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ALERT_CART_ITEM_ADDED_SUCCESS)));
//       const userDetails = utils.immutableToJS(utils.immutableUserDetails(getState));
//       const { device_id, token } = userDetails;
//       dispatch(fetchUserProfile({ token, device_id }));
//     }
//   } catch (err) {
//     dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
//   }
// };



// WEBPACK FOOTER //
// client/containers/GiftCardsList/actions.js